import { UIComponent } from "../../components";

export class AITemplateViewer extends UIComponent {
    init() {

    }

    onBack(cb) {
        this.btnBack.on("click", cb);
    }

    onEdit(cb) {
        this.BtnOptions.on("click", cb);
    }

    show({ id, name, content, url, categoryTitle }) {
        super.show();

        this.templateData = { id, name, content, url, categoryTitle };

        this.setTitle(name);
        this.setContent(content);
        this.setLink(url);
        this.setButton(categoryTitle);
    }

    setTitle(text) {
        this.title = text;
    }

    setContent(arr) {
        const inlineHtml = arr.reduce(
            (acc, { title, text }) => acc + this.createInlineHtml(title, text),
            ""
        );
        this.content.html(inlineHtml);
    }

    setLink(url) {
        this.btnUse.attr("href", url);
    }

    setButton(category) {
        if (category === "user_prompts") {
            this.BtnOptions.show();
        } else {
            this.BtnOptions.hide();
        }
    }

    createInlineHtml(title, content) {
        return `<div><h4>${title}</h4><p>${content}</p></div>`;
    }

    getTemplateData() {
        return this.templateData;
    }
}